import { FunctionComponent } from 'react';
import { AppRouting } from '../../../../AppRouting';
import { NavigationSection } from '../..';
import './LayoutSection.scss';
import { HeaderSection } from '../HeaderSection/HeaderSection';

export const LayoutSection: FunctionComponent = () => {
  return (
    <>
      <HeaderSection />
      <main className="layout-section">
        <NavigationSection />
        <AppRouting />
      </main>
    </>
  );
};
